/* istanbul ignore file */
import { CREATE_EXPENSE, useExpenseUrl } from 'domain/shared/expense';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateExpenseButton = () => {
  const { getCreateUrl } = useExpenseUrl();

  return (
    <CreateButton url={getCreateUrl()} label="Add expense" key="create-expense" permissionToCheck={CREATE_EXPENSE} />
  );
};

export default CreateExpenseButton;
